import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Users } from 'lucide-react';

export default function AlumniConnectionsTab({ connections, userId }) {
  if (connections.length === 0) {
    return (
      <Card className="border-0 shadow-sm rounded-2xl">
        <CardContent className="p-8 text-center">
          <Users className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground">No active mentorship connections yet.</p>
          <p className="text-sm text-muted-foreground mt-1">Browse alumni and request mentorship to get started!</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-3">
      {connections.map(conn => (
        <Card key={conn.id} className="border-0 shadow-sm rounded-2xl">
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center">
                  <Users className="text-emerald-600" size={24} />
                </div>
                <div>
                  <p className="font-semibold">{conn.mentee_id === userId ? conn.mentor_name : conn.mentee_name}</p>
                  <p className="text-sm text-muted-foreground">{conn.mentee_id === userId ? 'Your Mentor' : 'Your Mentee'}</p>
                </div>
              </div>
              <Badge className="bg-emerald-100 text-emerald-700">Connected</Badge>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
